import script from "./ViewViolators.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewViolators.vue?vue&type=script&setup=true&lang=js"

import "./ViewViolators.vue?vue&type=style&index=0&id=5ba16efd&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ba16efd"]])

export default __exports__